module.exports = __webpack_public_path__ + "img/android.1cec3020.png";